import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
import { limitedFilter, limitedBrowsingFilter } from './filters'
const db = firebaseApp.database()

const keyresultsRef = db.ref('keyresults')
const draftsKeyresultsRef = db.ref('drafts/keyresults')
const currentKeyresultsRef = (currentUserId) => { return db.ref('keyresults/' + currentUserId) }
const currentDraftsKeyresultsRef = (currentUserId) => { return db.ref('drafts/keyresults/' + currentUserId) }
export const keyResultsModule = {
  namespaced: true,
  state: {
    keyresults: {},
    draftsKeyresults: {},
    currentKeyresults: {},
    currentDraftsKeyresults: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_KEYRESULTS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_KEYRELULTS')
      bindFirebaseRef('keyresults', keyresultsRef, { wait: true })
    }),
    [getterConstants.GET_DRAFTS_KEYRESULTS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_DRAFTS_KEYRESULTS')
      bindFirebaseRef('draftsKeyresults', draftsKeyresultsRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_KEYRESULTS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_KEYRESULTS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentKeyresults', currentKeyresultsRef(currentUserId), { wait: true })
    }),
    [getterConstants.GET_CURRENT_DRAFTS_KEYRESULTS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_DRAFTS_KEYRESULTS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentDraftsKeyresults', currentDraftsKeyresultsRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_DRAFTS_KEYRESULTS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      draftsKeyresultsRef.child(currentUserId).remove()
      const newDraftsKeyresultRef = draftsKeyresultsRef.child(currentUserId).push()
      newDraftsKeyresultRef.set(value.keyresultInfo)
      for (const i in value.relationInfo) {
        const newDraftsRelationRef = db.ref('drafts/keyresults/' + currentUserId + '/' + newDraftsKeyresultRef.key + '/relations').push()
        newDraftsRelationRef.set(value.relationInfo[i])
      }
    }),
    [getterConstants.SET_NEW_KEYRESULT]: firebaseAction(async function (context, value) {
      console.log('value', value)
      const currentUserId = context.rootState.currentUserId
      if (!value.keyresultId) {
        const newKeyresultRef = keyresultsRef.child(currentUserId).push()
        newKeyresultRef.set(value.keyresultInfo)
        for (let i in value.relationInfo) {
          value.relationInfo[i].dir = 'dst'
          const newRelationRef = db
            .ref(
              'keyresults/' +
                currentUserId +
                '/' +
                newKeyresultRef.key +
                '/relations'
            )
            .push()
          newRelationRef.set(value.relationInfo[i]).catch(function (error) {
            console.log('error', error.message)
          })
        }
        // currentObjectivesRef.child(value.parentObjId).child('keyresults').child(newKeyresultRef.key).set(1)
        const setParentObjectivesRef = db.ref('objectives/' + currentUserId + '/' + value.keyresultInfo.parentObjId + '/keyresults/' + newKeyresultRef.key)
        setParentObjectivesRef.set(1)
      } else {
        const editKeyresultRef = await db
          .ref('keyresults/' + currentUserId + '/')
          .child(value.keyresultId)
        // await editKeyresultRef.update(value.keyresultInfo).catch(function (error) {
        editKeyresultRef.update(value.keyresultInfo).catch(function (error) {
          console.log('error-new-keyresult-relation', error.message)
        })
        for (let i in value.relationInfo) {
          value.relationInfo[i].dir = 'dst'
          const newRelationRef = await db
            .ref(
              'keyresults/' +
                currentUserId +
                '/' +
                value.keyresultId +
                '/relations'
            )
            .push()
          console.log(value.relationInfo[i])
          await newRelationRef.set(value.relationInfo[i]).catch(function (error) {
            console.log('error-edit-keyresult-relation', error.message)
          })
        }
      }
    }),
    [getterConstants.REMOVE_DRAFTS_KEYRESULTS]: firebaseAction((contest, value) => {
      const removeDraftsKeyresults = db.ref('drafts/keyresults/' + value)
      removeDraftsKeyresults.remove()
    })
  },
  getters: {
    getKeyresults: state => state.keyresults,
    getDraftKeyresults: state => state.draftsKeyresults,
    getCurrentKeyresults: state => state.currentKeyresults,
    getCurrentDraftKeyresults: state => state.currentDraftsKeyresults,
    getKeyresultById: (state, getters, rootState) => (keyresultId, userId, isAdmin, isForceBrowsing) => {
      let keyresults = null
      if (!!isAdmin || !!isForceBrowsing) {
        keyresults = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)[userId]
      } else {
        keyresults = limitedFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)[userId]
      }
      return (keyresults || {})[keyresultId] || {}
    },
    getKeyresultsByUserId: (state, getters, rootState) => (userId, isAdmin, isForceBrowsing) => {
      let stateKeyresults = null
      if (!!isAdmin || !!isForceBrowsing) {
        stateKeyresults = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)
      } else {
        stateKeyresults = limitedFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)
      }
      return stateKeyresults[userId] ? stateKeyresults[userId] : {}
    },
    // getObjectivesForPublic: (state, getters, rootState) => userId => {
    //   const objectives = state.objectives[userId]
    //   // let okrForShow = []
    //   console.log('objectives', objectives)
    //   for (const objkey in objectives) {
    //     if (objectives[objkey].limitedAccess) {
    //       console.log(objectives[objkey])
    //     } else {
    //       console.log('hogehoge')
    //     }
    //   }
    // },
    getCurrentKeyresultsByIds: (state, getters, rootState) => (keyresultIds) => {
      /* keyresultIds: Array */
      let keyresults = {}
      const stateCurrentKeyresults = state.currentKeyresults
      for (let keyresultId of keyresultIds) {
        if (stateCurrentKeyresults[keyresultId]) {
          keyresults[keyresultId] = stateCurrentKeyresults[keyresultId]
        }
      }
      return keyresults
    },
    getOtherUserKeyresultsByIds: (state, getters, rootState) => (userId, keyresultIds, isAdmin, isForceBrowsing) => {
      /* keyresultIds: Array */
      let keyresults = {}
      let stateKeyresults = null
      if (!!isAdmin || !!isForceBrowsing) {
        stateKeyresults = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)[userId]
      } else {
        stateKeyresults = limitedFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)[userId]
      }
      for (let keyresultId of keyresultIds) {
        if (stateKeyresults[keyresultId]) {
          keyresults[keyresultId] = stateKeyresults[keyresultId]
        }
      }
      return keyresults
    },
    getKeyresultsByParentObjId: (state, getters, rootState) => (itemId, isAdmin, isForceBrowsing) => {
      let keyresults = {}
      let stateKeyresults = null
      if (!!isAdmin || !!isForceBrowsing) {
        stateKeyresults = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)
      } else {
        stateKeyresults = limitedFilter(rootState.currentUserId, rootState.currentUser, state.keyresults)
      }
      for (let userId in stateKeyresults) {
        for (let kr in stateKeyresults[userId]) {
          if (stateKeyresults[userId][kr].parentObjId === itemId) {
            console.log('keyresult', stateKeyresults[userId][kr])
            keyresults[kr] = stateKeyresults[userId][kr]
          }
        }
      }
      console.log('keyresults', keyresults, itemId)
      return keyresults
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/keyResults.js